import { FormattedMessage } from "react-intl";

import styles from "./style.module.css";

export function TimeLimitInfo({ timeLimit }: { timeLimit: number }) {
  return (
    <div className={styles.timeLimitInfoContainer}>
      <p className={styles.text}>
        <FormattedMessage
          id="candidate.taking.timedSection"
          defaultMessage="<label>Timed Section:</label> {minutes} minutes"
          values={{
            label: (chunks) => <strong className={styles.upper}>{chunks}</strong>,
            minutes: timeLimit,
          }}
        />
      </p>
    </div>
  );
}
